import React, { useEffect, useMemo, useState } from 'react';
import { LegendColor, useMapLegendColors } from '@ais-ui/websockets';
import { LegendItem } from './LegendItem';

export const ColorBySourceType = () => {
  const [displayLegendItems, setDisplayLegendItems] = useState<LegendColor[]>(
    [],
  );

  const { data: legendColors } = useMapLegendColors();

  const validColors = useMemo(() => {
    return legendColors?.filter((item) => Boolean(item.color)) || [];
  }, [legendColors]);

  useEffect(() => {
    // Sort validColors alphabetically by name before setting to state
    const sortedValidColors = [...validColors].sort((a, b) =>
      a.name.localeCompare(b.name),
    );
    setDisplayLegendItems(sortedValidColors);
  }, [validColors]);

  return (
    <div className="p-4 grid grid-cols-3 gap-4 bg-background">
      {displayLegendItems.map((item) => {
        return (
          <LegendItem key={item.name} category={item.name} color={item.color} />
        );
      })}
    </div>
  );
};
